import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class ObjectFit extends BaseOption {
  static userInterfaceComponent = {
    label: "Object Fit",
    component: inspectorTools.RADIO_BAR,
    props: {
      iconSize: 24,
      options: [
        {
          icon: "object-cover",
          value: "cover",
        },
        {
          icon: "object-fit",
          value: "contain",
        },
      ],
    },
  };

  static defaultValue = "cover";
}
